import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { DashboardDetailsModel } from "../../models/DashboardDetailsModel";
import DashboardDetailsService from "../../services/DashboardDetailsService";
import DashboardDetailsSlice from "../slices/DashboardDetailsSlice";
import { RootState } from "../store";

export const DashboardDetailsActions = DashboardDetailsSlice.actions;

export const fetchParticularDashboardDetails = (
  userId: number,
  isFunnel: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(DashboardDetailsActions.setDashboardDetailsFetching(true))
    const response: DashboardDetailsModel[] =
      await DashboardDetailsService.getParticularDashboardDetails(
        userId,
        isFunnel
      );
    dispatch(DashboardDetailsActions.setParticularDashboardDetails(response));
    dispatch(DashboardDetailsActions.setDashboardDetailsFetching(false));
  };
};
